import React from 'react';
import style from './index.module.scss';

interface IPopUp {
  isOpen: boolean,
  onPopUp: () => void,
  text: string
}

const PopUp:React.FC<IPopUp> = ({  isOpen, onPopUp, text  }) => (
  <>
    {
      isOpen && (
        <div className={style.container}>
          <button aria-label='close' type='button' className={style.close} onClick={() => onPopUp()}>
            <svg width='14' height='14' viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg'>
              <line fill='none' stroke='#999' strokeWidth='1.1' x1='1' y1='1' x2='13' y2='13'/>
              <line fill='none' stroke='#999' strokeWidth='1.1' x1='13' y1='1' x2='1' y2='13'/>
            </svg>
          </button>
          <div className={style.body}>
            {text}
          </div>
        </div>
      )
    }
  </>
);

export default PopUp;